// FreeAgent API Configuration
// Live-only: uses production FreeAgent base URL

export const freeagentConfig = {
  // Production FreeAgent base URL (live-only)
  baseUrl: 'https://api.freeagent.com',
  
  // OAuth2 client credentials
  // NOTE: Client ID can be public (used in browser), but client secret is now handled server-side
  // For backward compatibility, we still check REACT_APP_ prefix, but client secret is no longer used in browser
  clientId: process.env.REACT_APP_FA_CLIENT_ID || '',
  clientSecret: '', // No longer used in browser - token exchange happens server-side
  
  // User agent for API requests (required)
  userAgent: process.env.REACT_APP_USER_AGENT || 'JARVIS/1.0',
  
  // Global sync enabled flag (default: off)
  syncEnabled: process.env.REACT_APP_FA_SYNC_ENABLED === 'true',
  
  // Token store key for localStorage
  tokenStoreKey: 'freeagent_access_token',
  refreshTokenStoreKey: 'freeagent_refresh_token',
  tokenExpiryStoreKey: 'freeagent_token_expiry',
};

/**
 * Check if FreeAgent sync is enabled and configured
 * NOTE: Client secret is now handled server-side, so we only check clientId and userAgent
 */
export function isFreeAgentConfigured(): boolean {
  return !!(
    freeagentConfig.clientId &&
    freeagentConfig.userAgent
  );
}

/**
 * Check if FreeAgent sync is enabled (both configured and globally enabled)
 */
export function isFreeAgentSyncEnabled(): boolean {
  const configured = isFreeAgentConfigured();
  const enabled = freeagentConfig.syncEnabled;
  
  // Debug logging
  if (process.env.NODE_ENV === 'development') {
    console.log('FreeAgent Config Check:', {
      syncEnabled: enabled,
      configured,
      hasClientId: !!freeagentConfig.clientId,
      hasUserAgent: !!freeagentConfig.userAgent,
      envSyncEnabled: process.env.REACT_APP_FA_SYNC_ENABLED,
      note: 'Client secret is now handled server-side via Vercel API routes',
    });
  }
  
  return enabled && configured;
}


